import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { buttonPress } from '../../services/vibration';

import Absolute from '../navigation/Absolute';
import Relative from '../navigation/Relative';

export default class Menu extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      open: false,
    };
    this.handleMenuToggle = this.handleMenuToggle.bind(this);
  }

  handleMenuToggle(event) {
    buttonPress(event);
    this.setState({ open: !this.state.open });
  }

  render() {
    const {
      canMoveNext,
      canMovePrevious,
      handleNextClick,
      handlePreviousClick,
      siteMotto,
      title,
    } = this.props;
    const { open } = this.state;
    return (
      <div id="menu" className={cx(this.state)}>
        <Absolute
          handleMenuToggle={this.handleMenuToggle}
          siteMotto={siteMotto}
          title={title}
        />
        <Relative
          canMoveNext={canMoveNext}
          canMovePrevious={canMovePrevious}
          handleMenuToggle={this.handleMenuToggle}
          handleNextClick={handleNextClick}
          handlePreviousClick={handlePreviousClick}
          open={open}
        />
      </div>
    );
  }
}

Menu.propTypes = {
  canMoveNext: PropTypes.bool,
  canMovePrevious: PropTypes.bool,
  handleNextClick: PropTypes.func.isRequired,
  handlePreviousClick: PropTypes.func.isRequired,
  siteMotto: PropTypes.string.isRequired,
  title: PropTypes.string.isRequired,
};

Menu.defaultProps = {
  canMoveNext: true,
  canMovePrevious: true,
};



// WEBPACK FOOTER //
// ./src/components/Menu/index.js